import StaticFooter from './StaticFooter';
export default StaticFooter;